<template lang="html">
  <b-dropdown class="w-100" toggle-class="border-0 bg-none m-md-2 text-dark" v-model="language">
    <template slot="button-content">
      <img class="flag-nav" :src="language === 'FR' ? logoFlagFR : logoFlagEN" alt="logo langue"/>{{ labelLanguage }}
    </template>
    <b-dropdown-item v-for="option in options" :key="option.value" @click="languageCountry(option.value)">
      <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" alt="logo Français"/>
      <img class="flag-nav" v-else :src="logoFlagEN" alt="logo anglais"/>
      <span>{{option.text}}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import FlagFRImage from './../../../assets/static/images/fr.png'
import FlagENImage from './../../../assets/static/images/gb.png'

export default {
  name: 'MobileLanguagePicker',
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      language: '',
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      options: []
    }
  },
  computed: {
    labelLanguage () {
      let lang = this.language
      let langOpt = this.options.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.$t('lang.french')
      if (langOpt.length) {
        label = langOpt[0].text
      }
      return label
    }
  },
  created () {
    this.language = this.$i18n.locale.toUpperCase()
    this.options = [
      { value: 'FR', text: this.$t('lang.french')},
      { value: 'EN', text: this.$t('lang.english')}
    ]
  },
  mounted () {
  },
  methods: {
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.options = [
        { value: 'FR', text: this.$t('lang.french')},
        { value: 'EN', text: this.$t('lang.english')}
      ]
    }
  }
}
</script>
